export class IncidentPermissionDetails {
  public INC_Add: boolean = false;
  public INC_Add_Unit: boolean = false;
  public INC_Owner_Unit: boolean = false;
  public INC_Owner: boolean = false;
  public INC_PotentialRAM_Unit: boolean = false;
  public INC_PotentialRAM: boolean = false;
  public INC_CAT_Unit: boolean = false;
  public INC_CAT: boolean = false;
  public INC_View_Unit: boolean = false;
  public INC_View: boolean = false;
  public INC_Admin_Unit: boolean = false;
  public INC_Admin: boolean = false;
  public INC_Author: boolean = false;
}
